import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import Home from '../views/Home.vue'
import AboutUs from '../views/AboutUs.vue'
import ContactUs from '../views/ContactUs.vue'
import Test from '../views/Test.vue'
import CoreOffers from '../views/CoreOffers.vue'
import SourceProduct from '../views/SourceProduct.vue'
import CategoryDetail from '../views/CategoryDetail.vue'
import CategoryFiltrationAccessoriesDetail from '../views/CategoryFiltrationAccessoriesDetail.vue'
import CategoryBeltConveyorDetail from '../views/CategoryBeltConveyorDetail.vue'
import CategoryFlowComponentsDetail from '../views/CategoryFlowComponentsDetail.vue'
import CategorySilosAndTanksDetail from '../views/CategorySilosAndTanksDetail.vue'
import CategoryDustRemovalSystemDetail from '../views/CategoryDustRemovalSystemDetail.vue'
import CategorySteelStructuresDetail from '../views/CategorySteelStructuresDetail.vue'
import { pushToDataLayer } from '../utils/gtm'; // 替换 gtag 引用
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            footerArcColor: 'transparent',
        },
    },
    {
        path: '/about',
        name: 'AboutUs',
        component: AboutUs,
        meta: {
            footerArcColor: '#ffffff',
        },
    },
    {
        path: '/contact-us',
        name: 'ContactUs',
        component: ContactUs,
        meta: {
            footerArcColor: 'transparent',
        },
    },
    {
        path: '/test',
        name: 'Test',
        component: Test
    },
    {
        path: '/core-offers',
        name: 'CoreOffers',
        component: CoreOffers,
        meta: {
            footerArcColor: 'transparent',
        },
    },
    {
        path: '/core-offers/source-product',
        name: 'SourceProduct',
        component: SourceProduct,
        meta: {
            footerArcColor: '#ffffff',
        },
    },
    {
        path: '/core-offers/source-product/fan',
        name: 'FanCategoryDetail',
        component: CategoryDetail,
        meta: {
            footerArcColor: '#ffffff',
        },
    },
    {
        path: '/core-offers/source-product/filtration-accessories',
        name: 'FiltrationAccessoriesCategoryDetail',
        component: CategoryFiltrationAccessoriesDetail,
        meta: {
            footerArcColor: '#ffffff',
        },
    },
    {
        path: '/core-offers/source-product/belt-conveyor',
        name: 'BeltConveyorCategoryDetail',
        component: CategoryBeltConveyorDetail,
        meta: {
            footerArcColor: '#ffffff',
        },
    },
    {
        path: '/core-offers/source-product/flow-components',
        name: 'FlowComponentsCategoryDetail',
        component: CategoryFlowComponentsDetail,
        meta: {
            footerArcColor: '#ffffff',
        },
    },
    {
        path: '/core-offers/source-product/silos-tanks',
        name: 'SilosAndTanksCategoryDetail',
        component: CategorySilosAndTanksDetail,
        meta: {
            footerArcColor: '#ffffff',
        },
    },
    {
        path: '/core-offers/source-product/dust-removal-system',
        name: 'DustRemovalSystemCategoryDetail',
        component: CategoryDustRemovalSystemDetail,
        meta: {
            footerArcColor: '#ffffff',
        },
    },
    {
        path: '/core-offers/source-product/steel-structures',
        name: 'SteelStructuresCategoryDetail',
        component: CategorySteelStructuresDetail,
        meta: {
            footerArcColor: '#ffffff',
        },
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
        meta: {
            footerArcColor: 'transparent',
        },
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 强制滚动到页面顶部
        return { top: 0 };
    },
});

router.afterEach((to, from) => {
  pushToDataLayer('page_view', {
    page_location: window.location.href,
    page_title: document.title,
    page_referrer: from.fullPath || document.referrer, // 兜底处理
  })
})

export default router
